/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} Timer — Free Online Countdown with Alarm | Toolverse`)
};

const es_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label} — Cuenta Regresiva Online Gratis con Alarma | Toolverse`)
};

const de_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}-Timer — Kostenloser Online-Countdown mit Alarm | Toolverse`)
};

const nl_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} Timer — Gratis Online Aftellen met Alarm | Toolverse`)
};

const fr_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Minuteur ${i?.label} — Compte à rebours en ligne gratuit avec alarme | Toolverse`)
};

const it_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timer ${i?.label} — Countdown Online Gratuito con Allarme | Toolverse`)
};

const pt_br2_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label} — Contagem Regressiva Online Grátis com Alarme | Toolverse`)
};

const pt_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Temporizador de ${i?.label} — Contagem Decrescente Online Gratuita com Alarme | Toolverse`)
};

const ja_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}タイマー — 無料のアラーム付きオンラインカウントダウン | Toolverse`)
};

const zh_timer_preset_meta_title = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}计时器 — 免费在线倒计时闹铃工具 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_meta_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_meta_title", locale)
	if (locale === "en") return en_timer_preset_meta_title(inputs)
	if (locale === "es") return es_timer_preset_meta_title(inputs)
	if (locale === "de") return de_timer_preset_meta_title(inputs)
	if (locale === "nl") return nl_timer_preset_meta_title(inputs)
	if (locale === "fr") return fr_timer_preset_meta_title(inputs)
	if (locale === "it") return it_timer_preset_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_meta_title(inputs)
	if (locale === "pt") return pt_timer_preset_meta_title(inputs)
	if (locale === "ja") return ja_timer_preset_meta_title(inputs)
	return zh_timer_preset_meta_title(inputs)
};